module.exports = __webpack_public_path__ + "media/images/course/aula_06-cc48d5074e1c33ddca5a5a66c3d729fd.png";